(function () {

  function initInstallationToggle() {

    const drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer || !drawer.classList.contains('is-open')) return;

    const wrapper = document.querySelector('[data-installation-wrapper]');
    const switchEl = document.getElementById('installation-switch');
    const message = document.getElementById('installation-help-message');

    if (!wrapper || !switchEl || !message) return;

    function setUI(value) {
      switchEl.checked = value === 'Ja';
      message.style.visibility = value === 'Ja' ? 'visible' : 'hidden';
    }

    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {

        if (cart.item_count === 0) {
          wrapper.classList.add('hidden');
          setUI('Nej');
          return;
        }

        wrapper.classList.remove('hidden');

        const choice = cart.attributes?.Installationshjälp || 'Nej';
        setUI(choice);
      });

    if (!switchEl.dataset.bound) {
      switchEl.addEventListener('change', function () {

        const value = switchEl.checked ? 'Ja' : 'Nej';

        setUI(value);

        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            attributes: { Installationshjälp: value }
          })
        });

      });

      switchEl.dataset.bound = '1';
    }
  }

  document.addEventListener('theme:cart:open', () => {
    setTimeout(initInstallationToggle, 150);
  });

})();